<template>
  <div style="display: flex; flex-direction: column">
    <div class="query-bar">
      <el-form ref="query" :model="query" inline>
        <el-form-item prop="billType" label="单据类型">
          <el-select
            v-model="query.billType"
            placeholder="请选择"
            size="small"
            style="width: 90px"
            clearable
          >
            <el-option label="订单" value="订单" />
            <el-option label="退货单" value="退货单" />
            <el-option label="应收单" value="应收单" />
          </el-select>
        </el-form-item>
        <el-form-item prop="fDistributor" label="经销商">
          <el-select-table2
            v-model="query.fDistributor"
            :label.sync="fNumber"
            search-key="name"
            url="BasicInformation/Distributor/DistributorChoiceEntry"
            label-field="fName"
            value-field="fName"
            size="small"
            :extra-param="{prohibit:false}"
            panel-width="500px"
            :columns="[
              { prop: 'fNumber', label: '编码' },
              { prop: 'fName', label: '名称' },

            ]"
          />
        </el-form-item>

        <el-form-item prop="fICItemID" label="产品">

          <el-select-table
            v-model="query.fICItemID"
            :label.sync="fName"
            url="ICItemManage/ICItem/ChoiceICItemEntry"
            label-field="fName"
            value-field="ficItemID"
            size="small"
            :extra-param="{prohibit:false}"
            panel-width="500px"
            :columns="[
              { prop: 'fNumber', label: '编码' },
              { prop: 'fName', label: '名称' },
              { prop: 'fModel', label: '规格' },
              { prop: 'fUnit', label: '单位' },
            ]"
          />
        </el-form-item>
        <el-form-item prop="startDate" label="日期">
          <el-date-picker
            v-model="query.startDate"
            type="date"
            placeholder="选择日期"
            size="small"
            style="width: 130px"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item prop="endDate" label="至">
          <el-date-picker
            v-model="query.endDate"
            type="date"
            placeholder="选择日期"
            style="width: 130px"
            value-format="yyyy-MM-dd"
            size="small"
          />
        </el-form-item>
      </el-form>

      <el-button
        type="primary"
        size="small"
        style="margin-right: 10px"
        @click="refresh"
      >查询</el-button>
      <el-button-export
        v-if="candown"
        :url="downloadUrl"
        type="primary"
        size="small"
      >下载报表</el-button-export>
    </div>
    <div style="flex: auto; display: flex; flex-direction: column">
      <el-table
        v-loading="loading"
        v-el-table-height-fix
        :data="tableData"
        height="100%"
      >
        <el-table-column prop="fDistributorNumber" label="经销商编号" width="110" />
        <el-table-column prop="fDistributor" label="经销商" min-width="160" />
        <el-table-column prop="fDate" label="日期" width="100" />
        <el-table-column prop="fCustomer" label="客户" min-width="160" />
        <el-table-column prop="fNumber" label="产品编码" width="100" />
        <el-table-column prop="fName" label="产品名称" width="100" />
        <el-table-column prop="fModel" label="规格" />
        <el-table-column prop="fUnit" label="单位" width="50" />
        <el-table-column prop="fQty" label="数量" width="60" />
        <el-table-column prop="fOrderPrice" label="销售单价" />
        <el-table-column prop="fPrice" label="结算价" />
        <el-table-column prop="fDeductionRatio" label="付款比例(%)" width="62" />
        <el-table-column prop="total" label="合计" width="90" />
        <el-table-column prop="orderBillNo" label="订单号" width="170" />
        <el-table-column prop="fBillNo" label="单号" width="170" />
        <el-table-column prop="fBatchNo" label="批号" width="120" />
        <el-table-column prop="fDate_Sc" label="生产日期" width="100" />
        <el-table-column prop="fDate_Xd" label="消毒日期" width="100" />
        <el-table-column prop="fDate_fh" label="发货日期 /确认日期" width="100" />
        <el-table-column prop="fDes" label="备注" />
      </el-table>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  data() {
    return {
      query: {
        billType: null,
        fDistributor: null,

        fICItemID: null,
        startDate: null,
        endDate: null
      },
      fNumber: '',
      fName: '',
      stockList: [],
      ICItemList: [],
      DistributorList: [],
      tableData: [],
      loading: false,
      currentEditItem: null,
      candown: true
    }
  },
  mounted() {
    // this.refresh()
    this.getStockEntry()

    const newtime = moment(new Date()).format('YYYY-MM-DD')
    this.query.startDate = newtime
    this.query.endDate = newtime
    //  根据权限设置编辑功能
    const userGrants = this.$store.state.userInfo.userGrants
    // console.log(userGrants,'userGrants')
    userGrants.forEach((val) => {
      if (val.key == '006005002') {
        this.candown = val.isGrant
      }
    })
  },
  methods: {
    refresh() {
      this.loading = true
      this.$httpPost('Report/AchievementReport', this.query)
        .then((res) => {
          if (!res.isSuccess) {
            this.$message.error(res.message)
            return
          }
          this.tableData = res.datalist
          this.pageRecordTotal = res.datalist.total
        })
        .finally(() => (this.loading = false))
    },
    getStockEntry() {
      this.$httpPost('Warehouse/Stock/StockEntry', {}).then((res) => {
        if (!res.isSuccess) {
          this.$message.error(res.message)
          return
        }
        this.stockList = res.datalist
      })
    },

    _view: function(row) {
      const url = this.$route.path + '/' + row.fid
      this.$router.push(url)
    },
    _delete: function(row) {
      this.$httpPost(`OrderManage/OrderTemporary/DeleteOrderTemporary`, {
        fid: row.fid
      }).then((res) => {
        if (res.isSuccess) {
          this.$message.success(res.message)
          this.refresh()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    downloadUrl: function() {
      const req = this.query
      return this.$buildDownloadUrl(
        'LogisticsSystemApi/Report/AchievementReportDownload',
        { ...req }
      )
    },
    dateFormat: function(row, column, cellValue) {
      var date = cellValue
      if (date == undefined) {
        return ''
      }
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>
<style scoped lang='less'>
.query-bar {
}
</style>
